import { type ChangeEvent, useState } from 'react';

import { GhostInput } from '@/components/form/inputs/ghost-input';
import { usePromiseCallback } from '@/hooks/use-promise-callback';

export type TaskUpdateTitleProps = {
  title?: string;
  required?: boolean;
  placeholder?: string;
  onChange: (title?: string) => Promise<void>;
  className?: string;
};

export function TaskUpdateTitle({
  title,
  required = false,
  placeholder,
  onChange,
  className,
}: TaskUpdateTitleProps) {
  const [input, setInput] = useState<string | undefined>(undefined);

  const [onSave, loading] = usePromiseCallback(
    async function (e: ChangeEvent<HTMLInputElement>) {
      const value = e.currentTarget.value?.trim() ?? '';

      if (value === (title ?? '')) {
        return;
      }
      if (required && !value) {
        setInput(undefined);
        return;
      }

      await onChange(value);
      setInput(undefined);
    },
    [onChange, setInput, title, required],
  );

  return (
    <GhostInput
      data-testid="task-title"
      required={required}
      className={className}
      value={input ?? title ?? ''}
      placeholder={placeholder}
      onChange={(e) => setInput(e.currentTarget.value)}
      onBlur={onSave}
      disabled={loading}
    />
  );
}
